export default {
  empty_payment_method: {
    add: 'Add Payment Method',
  },
};
